import { render, staticRenderFns } from "./CollapsiblePanel.vue?vue&type=template&id=2dc085b2&scoped=true"
import script from "./CollapsiblePanel.vue?vue&type=script&lang=js"
export * from "./CollapsiblePanel.vue?vue&type=script&lang=js"
import style0 from "./CollapsiblePanel.vue?vue&type=style&index=0&id=2dc085b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc085b2",
  null
  
)

export default component.exports